module.exports = __webpack_public_path__ + "static/foto-58e65cee0bfbf7c04c192ba84c58d56f.jpg";